import { create } from 'zustand';
export interface IShopMeta {
  key: string;
  value: string;
}
export interface IShopMetaStore {
  shopMeta?: IShopMeta[];
  isQueryShopMetaDefault: boolean;
  setShopMeta: (shopMeta: IShopMeta[]) => void;
  setIsQueryShopMetaDefault: (isQueryShopMetaDefault: boolean) => void;
}

export const useShopMetaStore = create<IShopMetaStore>()((set, get) => ({
  shopMeta: undefined,
  isQueryShopMetaDefault: false,
  setShopMeta: (data) => {
    const currentShopMeta = get().shopMeta?.filter((item) => !data.find((d) => d.key === item.key));
    const newShopMeta = [...(currentShopMeta || []), ...data];
    set({ shopMeta: newShopMeta });
  },
  setIsQueryShopMetaDefault: (isQueryShopMetaDefault) => set({ isQueryShopMetaDefault }),
}));

export default useShopMetaStore;
